import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

export const ServiceMap = () => {
  const cities = [
    { name: 'Broward County', position: { top: '25%', left: '55%' } },
    { name: 'Miami', position: { top: '50%', left: '60%' } },
    { name: 'Florida Keys', position: { top: '85%', left: '35%' } },
  ];


  return (
    <section
      data-testid="service-map-section"
      className="py-20 md:py-32 bg-slate-900 text-white overflow-hidden">

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative aspect-square max-w-md mx-auto lg:mx-0">

            {/* South Florida Map SVG */}
            <svg
              viewBox="0 0 400 500"
              className="w-full h-full"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">

              {/* South Florida outline - focusing on Miami-Dade, Broward, and Keys */}
              <path
                d="M80 20 L320 20 L340 40 L350 80 L345 120 L340 160 L330 200 L310 240 L280 280 L250 320 L220 350 L180 380 L140 400 L100 420 L60 450 L40 470 L30 480 L50 460 L80 430 L60 400 L50 360 L55 320 L60 280 L65 240 L70 200 L75 160 L78 120 L80 80 L80 20"
                fill="#334155"
                stroke="#f97316"
                strokeWidth="3" />

              {/* Florida Keys chain */}
              <path
                d="M30 480 L60 475 L100 465 L140 455 L180 450 L220 448 L260 450"
                fill="none"
                stroke="#f97316"
                strokeWidth="3" />
              
              {/* Keys islands */}
              <circle cx="60" cy="475" r="8" fill="#334155" stroke="#f97316" strokeWidth="2" />
              <circle cx="100" cy="465" r="6" fill="#334155" stroke="#f97316" strokeWidth="2" />
              <circle cx="140" cy="455" r="7" fill="#334155" stroke="#f97316" strokeWidth="2" />
              <circle cx="180" cy="450" r="5" fill="#334155" stroke="#f97316" strokeWidth="2" />

              {/* Glow effect */}
              <path
                d="M80 20 L320 20 L340 40 L350 80 L345 120 L340 160 L330 200 L310 240 L280 280 L250 320 L220 350 L180 380 L140 400 L100 420 L60 450 L40 470 L30 480"
                fill="none"
                stroke="#f97316"
                strokeWidth="1"
                opacity="0.3"
                filter="blur(10px)" />

            </svg>

            {/* City dots */}
            {cities.map((city, index) =>
            <motion.div
              key={city.name}
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 + index * 0.1, duration: 0.4 }}
              className="absolute group cursor-pointer"
              style={city.position}>

                {/* Pulse effect */}
                <div className="absolute inset-0 w-4 h-4 bg-orange-500 rounded-full animate-ping opacity-75" />
                {/* Dot */}
                <div className="relative w-4 h-4 bg-orange-500 rounded-full border-2 border-white shadow-lg" />
                {/* Label */}
                <div className="absolute left-6 top-1/2 -translate-y-1/2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity bg-white text-slate-900 px-2 py-1 text-xs font-semibold">
                  {city.name}
                </div>
              </motion.div>
            )}
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}>

            <span className="inline-block font-heading text-sm font-semibold tracking-widest uppercase text-orange-500 mb-4">
              Coverage Area
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight uppercase text-white mb-6">
              Serving All of
              <span className="block text-orange-500">South Florida</span>
            </h2>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed">From Broward County to Downtown Miami, down to the Florida Keys, we provide professional concrete cutting services throughout the entirety of South Florida. Our mobile teams are equipped to handle any project, anywhere.



            </p>

            {/* Service areas list */}
            <div className="grid grid-cols-2 gap-4">
              {cities.map((city) =>
              <div
                key={city.name}
                className="flex items-center gap-3 text-slate-300">

                  <MapPin className="h-4 w-4 text-orange-500 flex-shrink-0" />
                  <span className="font-medium">{city.name}</span>
                </div>
              )}
            </div>

            <p className="mt-8 text-slate-400 text-sm">
              Don't see your city? We likely service your area too. 
              <button className="text-orange-500 hover:text-orange-400 ml-1 underline">
                Contact us
              </button> to confirm.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Background text */}
      <div className="absolute right-0 bottom-0 font-heading text-[15rem] font-bold text-slate-800/30 leading-none tracking-tighter pointer-events-none hidden xl:block">
        FL
      </div>
    </section>);

};

export default ServiceMap;